import React, { useState, useRef, useEffect } from "react";
import useModalFocus from "../../hooks/useModalFocus";
import { Upload, X } from "lucide-react";
import styled from "styled-components";
import SiteHeader from "../landing/components/Header/SiteHeader";
import Footer from "../landing/components/Footer/Footer";
import Breadcrumb from "../about/components/Breadcrumb/Breadcrumb";
import contactUs from "../../assets/images/contactUs.png";
import { useDispatch, useSelector } from "react-redux";
import {

  MapPin,
  Phone,
  Mail,
  Clock,
} from "lucide-react";
import {
  verifyGrievanceMobile,
  createGrievanceUser,
  generateGrievanceOtp,
  verifyGrievanceOtp,
  submitGrievance,
} from "../../redux/grievance/grievanceSlice";
import { fetchCategorySubcategories } from "../../redux/categorySubcategory/categorySubcategorySlice";
import {
  clearLoanVerification,
  sendAlumniForm,
  verifyLoanAccount,
} from "../../redux/alumni/alumniSlice";
import {
  deleteUploadedFile,
  FILE_BUCKETS,
  uploadFile,
} from "../../services/fileService";

const MAX_GRIEVANCE_FILE_SIZE = 1024 * 1024;
const DEFAULT_OTP_USER_ID = 1;

const BreadcrumbWrapper = styled.div`
  z-index: 1000;
  padding: 8px 80px 6px;

  @media (max-width: 768px) {
    padding: 8px 16px 12px;
  }
`;

const TitleWrapper = styled.div`
  background: #f4f7f6;
  background-size: cover;
  background-position: center;
  padding: 28px 73px  6px;
  color: Black;

  @media (max-width: 768px) {
    padding: 6px 16px 14px;
  }
`;

const PageTitle = styled.h1`
  color: #1b3a6b;
  
  font-size: 23px;
  line-height: 1.2;
  font-weight: 700;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;

  &::first-letter {
    color: #ff9933;
  }

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const ContactUs = () => {
  const dispatch = useDispatch();
  const categorySubcategoryState = useSelector((state) => state.categorySubcategory);
  const grievanceCategoryState = categorySubcategoryState;
  const grievanceState = useSelector((state) => state.grievance);
  const alumniState = useSelector((state) => state.alumni || { status: "idle", error: "" });

  // Main Category States
  const [isGrievanceOpen, setIsGrievanceOpen] = useState(false);
  const [selectedGrievance, setSelectedGrievance] = useState("");
  const dropdownRef = useRef(null);

  const grievanceOptions = categorySubcategoryState.categories;
  const selectedGrievanceOption = grievanceOptions.find((opt) => opt.value === selectedGrievance);
  const selectedGrievanceCode = (selectedGrievanceOption?.code || "").toLowerCase();
  const isNmdfcGrievanceSelected = selectedGrievanceCode === "department";
  const isOtherGrievanceSelected = selectedGrievanceCode === "other";
  // All sub-categories arrive up front in the combined API call, grouped by categoryId.
  const subCategoryList = selectedGrievance
    ? categorySubcategoryState.subCategoriesByCategoryId[selectedGrievance] || []
    : [];
  const isSubCategoryLoading = categorySubcategoryState.status === "loading";
  const subCategoryError = categorySubcategoryState.status === "failed" ? categorySubcategoryState.error : "";

  // Sub-Category States
  const [isSubCategoryOpen, setIsSubCategoryOpen] = useState(false);
  const [subCategory, setSubCategory] = useState("");
  // The selected sub-category option's id/name, sent as referenceId/referenceNameSnapshot on submit.
  const [subCategoryReferenceId, setSubCategoryReferenceId] = useState("");
  const [subCategoryReferenceName, setSubCategoryReferenceName] = useState("");
  const subCategoryDropdownRef = useRef(null);

  // Accordion states
  const [isContactSectionOpen, setIsContactSectionOpen] = useState(false);
  const [isAlumniSectionOpen, setIsAlumniSectionOpen] = useState(false);

  // File Upload States
  const [attachedFile, setAttachedFile] = useState(null);
  const [grievanceDocument, setGrievanceDocument] = useState(null);
  const [grievanceUploadStatus, setGrievanceUploadStatus] = useState("idle");
  const fileInputRef = useRef(null);

  const [alumniAttachedFile, setAlumniAttachedFile] = useState(null);
  const [alumniEducationProof, setAlumniEducationProof] = useState(null);
  const [alumniUploadStatus, setAlumniUploadStatus] = useState("idle");
  const [alumniFileError, setAlumniFileError] = useState("");
  const alumniFileInputRef = useRef(null);
  const [alumniForm, setAlumniForm] = useState({
    name: "",
    email: "",
    course: "",
    completionDate: "",
    loanAccount: "",
    loanDate: "",
    profession: "",
    NameOfInstitute: "",
  });

  // Form Submission & Verification States
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpStep, setOtpStep] = useState(1); // 1 for input, 2 for success
  const [otp, setOtp] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [submissionType, setSubmissionType] = useState("grievance");

  // Resend OTP Timer State
  const [resendTimer, setResendTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [grievancePhone, setGrievancePhone] = useState("");
  const [grievanceName, setGrievanceName] = useState("");
  const [grievanceDescription, setGrievanceDescription] = useState("");
  const [grievanceSubmitError, setGrievanceSubmitError] = useState("");
  const [grievanceFileError, setGrievanceFileError] = useState("");
  const [grievanceErrors, setGrievanceErrors] = useState({});
  const grievanceNameRef = useRef(null);
  const grievancePhoneRef = useRef(null);
  const grievanceCategoryRef = useRef(null);
  const grievanceSubCategoryRef = useRef(null);
  const grievanceDescriptionRef = useRef(null);
  const grievanceFileRef = useRef(null);

  const setGrievancePhoneError = (msg) => {
    setGrievanceErrors((prev) => ({ ...prev, phone: msg }));
  };
  const phoneCheckId = useRef(0);
  const [alumniEmailError, setAlumniEmailError] = useState("");
  const [loanVerificationError, setLoanVerificationError] = useState("");
  const activeModal = loanVerificationError ? "loan-error" : showModal ? "submission" : showOtpModal ? `otp-${otpStep}` : "";
  const modalRef = useModalFocus(activeModal, () => {
    if (loanVerificationError) setLoanVerificationError("");
    else if (showModal) setShowModal(false);
    else setShowOtpModal(false);
  });
  const loanAccountRef = useRef("");
  // Mobile-check API didn't find this number, so a grievance user still needs to be created.
  const [isNewGrievanceUser, setIsNewGrievanceUser] = useState(false);
  // Guards against creating the same user twice (e.g. double-click on Verify).
  const grievanceUserCreatedRef = useRef(false);
  // Captured directly from the mobile-check/create-user response, used at final submit.
  const grievanceUserIdRef = useRef(null);
  const otpUserIdRef = useRef(null);

  const phoneRegex = /^\d{10}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const today = new Date().toISOString().split("T")[0];

const handleDateKeyDown = (e) => {
  // Prevent manual date typing
  e.preventDefault();
};
const openDatePicker = (e) => {
  e.currentTarget.showPicker?.();
};
  const handlePhoneBlur = () => {
    if (!grievancePhone.trim()) {
      return;
    }
    if (!phoneRegex.test(grievancePhone)) {
      setGrievanceErrors((prev) => ({
        ...prev,
        phone: "Please enter a valid 10-digit phone number.",
      }));
    } else {
      setGrievanceErrors((prev) => ({
        ...prev,
        phone: "",
      }));
    }
  };

  const validateGrievanceForm = () => {
    const errors = {};

    if (!grievanceName.trim()) {
      errors.name = "Please enter your name.";
    }

    if (!grievancePhone.trim()) {
      errors.phone = "Please enter your mobile number.";
    } else if (!phoneRegex.test(grievancePhone)) {
      errors.phone = "Please enter a valid 10-digit phone number.";
    }

    if (!selectedGrievance) {
      errors.category = "Please select a grievance category.";
    }

    if (!isNmdfcGrievanceSelected) {
      if (isOtherGrievanceSelected) {
        if (!subCategory.trim()) {
          errors.subCategory = "Please enter a sub-category.";
        }
      } else {
        if (!subCategoryReferenceId) {
          errors.subCategory = "Please select a sub-category.";
        }
      }
    } else {
      if (!subCategoryReferenceId) {
        errors.category = "Administration is not available. Please try again.";
      }
    }

    if (!grievanceDescription.trim()) {
      errors.description = "Please enter the grievance description.";
    }

    if (attachedFile && attachedFile.size >= MAX_GRIEVANCE_FILE_SIZE) {
      errors.file = "The document must be less than 1 MB.";
    } else if (
      grievanceUploadStatus === "uploading" ||
      grievanceUploadStatus === "deleting" ||
      (attachedFile && !grievanceDocument)
    ) {
      errors.file = "Please wait for the document upload to finish.";
    }

    return errors;
  };

  const focusFirstGrievanceError = (errors) => {
    if (errors.name) {
      grievanceNameRef.current?.focus();
    } else if (errors.phone) {
      grievancePhoneRef.current?.focus();
    } else if (errors.category) {
      grievanceCategoryRef.current?.focus();
    } else if (errors.subCategory) {
      grievanceSubCategoryRef.current?.focus();
    } else if (errors.description) {
      grievanceDescriptionRef.current?.focus();
    } else if (errors.file) {
      grievanceFileRef.current?.focus();
    }
  };

  const validateEmailAddress = (value) => {
    if (!emailRegex.test(value.trim())) {
      setAlumniEmailError("Please enter a valid email address.");
      return false;
    }
    setAlumniEmailError("");
    return true;
  };

  useEffect(() => {
    if (alumniState.status === "succeeded") {
      setSubmissionType("alumni");
      setShowModal(true);
      setAlumniForm({
        name: "",
        email: "",
        course: "",
        completionDate: "",
        loanAccount: "",
        loanDate: "",
        profession: "",
        NameOfInstitute: "",
      });
      setAlumniAttachedFile(null);
      dispatch(clearLoanVerification());
    }
  }, [alumniState.status, dispatch]);

  const checkGrievanceMobile = async (mobileNumber) => {
    if (!phoneRegex.test(mobileNumber)) {
      return;
    }

    const checkId = phoneCheckId.current;

    try {
      const result = await dispatch(verifyGrievanceMobile(mobileNumber)).unwrap();

      if (checkId === phoneCheckId.current) {
        setIsPhoneVerified(true);
        setGrievancePhoneError("");
        // Existing user, so no create-user call is needed later.
        setIsNewGrievanceUser(false);
        grievanceUserIdRef.current = result.userId ?? null;
      }
    } catch (error) {
      if (checkId === phoneCheckId.current) {
        setIsPhoneVerified(false);
        setGrievancePhoneError("");
        // Number wasn't found, so this is a new user pending OTP verification.
        setIsNewGrievanceUser(true);
        grievanceUserCreatedRef.current = false;
      }
    }
  };

  // Best practice: create the grievance user right after OTP verification succeeds,
  // not before (unverified numbers shouldn't create accounts) and not after final
  // submit (the record must already exist before the grievance can be submitted).
  const handleOtpVerified = async () => {
    setGrievanceSubmitError("");

    try {
      await dispatch(
        verifyGrievanceOtp({
          userId: otpUserIdRef.current ?? DEFAULT_OTP_USER_ID,
            recipientValue: grievancePhone,
              purposeId: 10,
          otp,
        })
      ).unwrap();

      if (isNewGrievanceUser && !grievanceUserCreatedRef.current) {
        grievanceUserCreatedRef.current = true;
        try {
          const result = await dispatch(
            createGrievanceUser({
              userName: grievanceName,
              mobileNo: grievancePhone,
            })
          ).unwrap();
          // Captured directly from the create-user response, used at final submit.
          grievanceUserIdRef.current = result.userId ?? null;
        } catch (error) {
          // Allow a retry on the next verify attempt if user creation failed.
          grievanceUserCreatedRef.current = false;
          setGrievanceSubmitError(
            typeof error === "string"
              ? error
              : "Unable to create your grievance profile. Please try again."
          );
          return;
        }
      }

      setIsPhoneVerified(true);
      setOtpStep(2);
    } catch (error) {
      setGrievanceSubmitError(
        typeof error === "string" ? error : "Invalid OTP. Please try again."
      );
    }
  };

  const handleSendGrievanceOtp = async () => {
    setGrievanceSubmitError("");

    try {
      let userId = grievanceUserIdRef.current;

      // Ensure the OTP request uses the user associated with the current mobile number.
      if (userId == null) {
        try {
          const result = await dispatch(verifyGrievanceMobile(grievancePhone)).unwrap();
          userId = result.userId ?? null;
          setIsNewGrievanceUser(userId == null);
        } catch (error) {
          // New users are created only after the OTP has been verified.
          setIsNewGrievanceUser(true);
          setGrievancePhoneError("");
        }
      }

      otpUserIdRef.current = userId ?? DEFAULT_OTP_USER_ID;

      await dispatch(
        generateGrievanceOtp({
          purposeId: 10,
          channelId: 3,
          referenceType: Number(selectedGrievance) || selectedGrievance,
          referenceId: Number(subCategoryReferenceId) || subCategoryReferenceId || "",
          recipientValue: grievancePhone,
          userId: otpUserIdRef.current,
        })
      ).unwrap();

      setOtpStep(1);
      setOtp("");
      setResendTimer(30);
      setCanResend(false);
      setShowOtpModal(true);
    } catch (error) {
      setGrievanceSubmitError(
        typeof error === "string" ? error : "Unable to send OTP. Please try again."
      );
    }
  };

  // Final "Submit Grievance" call, made after the grievance user already exists.
  const handleFinalGrievanceSubmit = async () => {
    setGrievanceSubmitError("");

    const errors = validateGrievanceForm();
    if (Object.keys(errors).length > 0) {
      setGrievanceErrors(errors);
      focusFirstGrievanceError(errors);
      return;
    }

    try {
      // Guard against a stale/missing ref: re-fetch the userId from the mobile-check
      // API right before submit so an already-registered user never submits without one.
      if (grievanceUserIdRef.current == null && !isNewGrievanceUser) {
        try {
          const result = await dispatch(verifyGrievanceMobile(grievancePhone)).unwrap();
          grievanceUserIdRef.current = result.userId ?? null;
        } catch (lookupError) {
          setGrievanceSubmitError("Unable to verify this mobile number. Please try again.");
          return;
        }
      }

      if (grievanceUserIdRef.current == null) {
        setGrievanceSubmitError("Unable to verify this mobile number. Please try again.");
        return;
      }

      // The API's "requiresReference" flag contradicts itself (e.g. "Loan" needs a
      // reference despite requiresReference: false), so always send it when available.
      await dispatch(
        submitGrievance({
          userId: grievanceUserIdRef.current,
          categoryId: Number(selectedGrievance) || selectedGrievance,
          referenceId: isOtherGrievanceSelected
            ? null
            : Number(subCategoryReferenceId) || subCategoryReferenceId || null,
          referenceNameSnapshot: isOtherGrievanceSelected ? subCategory : subCategoryReferenceName,
          complaintStatement: grievanceDescription,
          document: grievanceDocument,
        })
      ).unwrap();
      setShowOtpModal(false);
      setShowModal(true);
    } catch (error) {
      // Logged so the actual API/network failure is visible in devtools, not just the generic message.
      console.error("Grievance submission failed:", error);
      const message = typeof error === "string" ? error : "Unable to submit grievance. Please try again.";

      if (message.toLowerCase().includes("does not exist as an active")) {
        // The list API returned this record without exposing whether it's actually active,
        // so the backend rejected it only at submit time. Force the user to pick again.
        setSubCategory("");
        setSubCategoryReferenceId("");
        setSubCategoryReferenceName("");
        setGrievanceErrors((prev) => ({
          ...prev,
          subCategory: "This selection is no longer available. Please choose a different Sub-Category and try again.",
        }));
        grievanceSubCategoryRef.current?.focus();
        return;
      }

      setGrievanceSubmitError(message);
    }
  };

  const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "Contact Us", path: "/contact-us" },
  ];

  // Resend OTP countdown logic
  useEffect(() => {
    let timer;
    if (showOtpModal && otpStep === 1 && resendTimer > 0) {
      timer = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    } else if (resendTimer === 0) {
      setCanResend(true);
    }
    return () => clearInterval(timer);
  }, [showOtpModal, otpStep, resendTimer]);

  // Handle hash navigation to open & scroll to grievance or alumni forms
  useEffect(() => {
    const handleHashChange = () => {
      const hash = (window.location.hash || window.location.search).toLowerCase();
      if (hash.includes("grievance")) {
        setIsContactSectionOpen(true);
        setTimeout(() => {
          document.getElementById("grievance-section")?.scrollIntoView({ behavior: "smooth" });
        }, 150);
      } else if (hash.includes("alumni")) {
        setIsAlumniSectionOpen(true);
        setTimeout(() => {
          document.getElementById("alumni-section")?.scrollIntoView({ behavior: "smooth" });
        }, 150);
      }
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleResendOtp = async () => {
    if (!canResend || grievanceState.otpStatus === "loading") {
      return;
    }

    await handleSendGrievanceOtp();
  };

  // Close custom dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsGrievanceOpen(false);
      }

      if (
        subCategoryDropdownRef.current &&
        !subCategoryDropdownRef.current.contains(event.target)
      ) {
        setIsSubCategoryOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Loads the combined category/subcategory data for both dropdowns once on mount.
  useEffect(() => {
    dispatch(fetchCategorySubcategories());
  }, [dispatch]);

  // Resets the Sub-Category selection whenever the "Grievance With" selection changes.
  useEffect(() => {
    setSubCategory("");
    setSubCategoryReferenceId("");
    setSubCategoryReferenceName("");
    setIsSubCategoryOpen(false);
  }, [selectedGrievance]);

  useEffect(() => {
    if (!isNmdfcGrievanceSelected) {
      return;
    }

    const administrationOption = subCategoryList.find(
      (option) => option.label.trim().toLowerCase() === "administration"
    );

    if (administrationOption) {
      setSubCategory(administrationOption.value);
      setSubCategoryReferenceId(administrationOption.value);
      setSubCategoryReferenceName(administrationOption.label);
    }
  }, [isNmdfcGrievanceSelected, subCategoryList]);

  /**
   * Retries the combined category/subcategory API request.
   */
  const handleSubCategoryRetry = () => {
    dispatch(fetchCategorySubcategories());
  };

  // Handle File Input Change
  const handleFileChange = async (e) => {
    const selectedFile = e.target.files?.[0];

    if (!selectedFile) {
      return;
    }

    if (selectedFile.size >= MAX_GRIEVANCE_FILE_SIZE) {
      setAttachedFile(null);
      setGrievanceFileError("The document must be less than 1 MB.");
      e.target.value = "";
      return;
    }

    setGrievanceFileError("");
    setGrievanceUploadStatus("uploading");

    try {
      const uploadedDocument = await uploadFile(selectedFile, FILE_BUCKETS.GRIEVANCE);
      setAttachedFile(selectedFile);
      setGrievanceDocument(uploadedDocument);
      setGrievanceUploadStatus("uploaded");
    } catch (error) {
      setAttachedFile(null);
      setGrievanceDocument(null);
      setGrievanceUploadStatus("failed");
      setGrievanceFileError(error.message);
      e.target.value = "";
    }
  };

  const handleAlumniFileChange = async (e) => {
    const selectedFile = e.target.files?.[0];
    if (!selectedFile) return;

    if (selectedFile.size >= MAX_GRIEVANCE_FILE_SIZE) {
      setAlumniFileError("The document must be less than 1 MB.");
      e.target.value = "";
      return;
    }

    setAlumniFileError("");
    setAlumniUploadStatus("uploading");

    try {
      const uploadedDocument = await uploadFile(selectedFile, FILE_BUCKETS.ALUMNI);
      setAlumniAttachedFile(selectedFile);
      setAlumniEducationProof(uploadedDocument);
      setAlumniUploadStatus("uploaded");
    } catch (error) {
      setAlumniAttachedFile(null);
      setAlumniEducationProof(null);
      setAlumniUploadStatus("failed");
      setAlumniFileError(error.message);
      e.target.value = "";
    }
  };

  const removeGrievanceFile = async () => {
    if (!grievanceDocument) return;

    setGrievanceFileError("");
    setGrievanceUploadStatus("deleting");
    try {
      await deleteUploadedFile({
        bucket: grievanceDocument.bucket || FILE_BUCKETS.GRIEVANCE,
        objectPath: grievanceDocument.objectPath,
      });
      setAttachedFile(null);
      setGrievanceDocument(null);
      setGrievanceUploadStatus("idle");
      if (fileInputRef.current) fileInputRef.current.value = "";
    } catch (error) {
      setGrievanceUploadStatus("uploaded");
      setGrievanceFileError(error.message);
    }
  };

  const removeAlumniFile = async () => {
    if (!alumniEducationProof) return;

    setAlumniFileError("");
    setAlumniUploadStatus("deleting");
    try {
      await deleteUploadedFile({
        bucket: alumniEducationProof.bucket || FILE_BUCKETS.ALUMNI,
        objectPath: alumniEducationProof.objectPath,
      });
      setAlumniAttachedFile(null);
      setAlumniEducationProof(null);
      setAlumniUploadStatus("idle");
      if (alumniFileInputRef.current) alumniFileInputRef.current.value = "";
    } catch (error) {
      setAlumniUploadStatus("uploaded");
      setAlumniFileError(error.message);
    }
  };

  // Modified Form Submission Handler
  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setGrievanceSubmitError("");

    const errors = validateGrievanceForm();
    if (Object.keys(errors).length > 0) {
      setGrievanceErrors(errors);
      focusFirstGrievanceError(errors);
      return;
    }

    setGrievanceErrors({});

    setSubmissionType("grievance");
    if (!isPhoneVerified) {
      await handleSendGrievanceOtp();
    } else {
      // Already-verified user: submit the grievance right away.
      await handleFinalGrievanceSubmit();
    }
  };

  const handleAlumniSubmit = (e) => {
    if (e) e.preventDefault();

    const loanVerification = alumniState.loanVerification;
    if (
      loanVerification?.status !== "succeeded" ||
      loanVerification.accountNumber !== alumniForm.loanAccount.trim() ||
      !alumniForm.loanDate
    ) {
      setLoanVerificationError("This loan account does not exist or has not been verified.");
      return;
    }

    if (!validateEmailAddress(alumniForm.email)) {
      return;
    }

    const payload = {
      loanAccountNumber: alumniForm.loanAccount.trim(),
      loanDate: alumniForm.loanDate,
      beneficiaryName: alumniForm.name,
      beneficiaryEmailId: alumniForm.email,
      educationCourseDegree: alumniForm.course,
      educationInstituteName: alumniForm.NameOfInstitute,
      educationCompletionDate: alumniForm.completionDate,
      currentProfessionDesc: alumniForm.profession,
    };

    if (alumniUploadStatus === "uploading" || alumniUploadStatus === "deleting") {
      setAlumniFileError("Please wait for the document upload to finish.");
      return;
    }

    if (alumniAttachedFile && !alumniEducationProof) {
      setAlumniFileError("Please wait for the document upload to finish.");
      return;
    }

    setSubmissionType("alumni");
    dispatch(sendAlumniForm({ data: payload, educationProof: alumniEducationProof }));
  };

  const handleLoanAccountBlur = async () => {
    const loanAccountNumber = alumniForm.loanAccount.trim();
    loanAccountRef.current = loanAccountNumber;
    setLoanVerificationError("");

    if (!loanAccountNumber) {
      dispatch(clearLoanVerification());
      return;
    }

    try {
      const loanDetails = await dispatch(verifyLoanAccount(loanAccountNumber)).unwrap();

      if (loanAccountRef.current === loanAccountNumber) {
        setAlumniForm((prev) => ({
          ...prev,
          loanDate: loanDetails.loanDate,
        }));
      }
    } catch (error) {
      if (loanAccountRef.current === loanAccountNumber) {
        setAlumniForm((prev) => ({ ...prev, loanDate: "" }));
        setLoanVerificationError(error || "This loan account does not exist.");
      }
    }
  };

  const isAlumniFormValid = () => {
    const loanVerification = alumniState.loanVerification;

    return Boolean(
      alumniForm.name.trim() &&
      alumniForm.email.trim() &&
      emailRegex.test(alumniForm.email) &&
      alumniForm.course.trim() &&
      alumniForm.completionDate &&
      alumniForm.NameOfInstitute.trim() &&
      alumniForm.loanAccount.trim() &&
      alumniForm.loanDate &&
      alumniForm.profession.trim() &&
      loanVerification?.status === "succeeded" &&
      loanVerification.accountNumber === alumniForm.loanAccount.trim()
    );
  };

  return (
    <div className="min-h-screen">
      <SiteHeader>
        <BreadcrumbWrapper>
          <Breadcrumb items={breadcrumbItems} />
        </BreadcrumbWrapper>
      </SiteHeader>

      <div className="flex-1 p-0">
        <TitleWrapper>
          <PageTitle>Contact Us</PageTitle>
        </TitleWrapper>
      </div>

      <main id="main-content" tabIndex={-1} className="relative overflow-hidden bg-[#f4f7f6]">
        <div className="relative mx-auto max-w-screen-xl px-4 py-8 sm:px-6 lg:px-8 lg:py-10">
          <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
            {/* Left Side Section */}
         <section className="relative h-[41rem] overflow-hidden rounded-2xl border border-white/70 shadow-[0_24px_80px_-35px_rgba(37,99,235,0.55)]">

  <img
    src={contactUs}
    alt="Contact Us"
    className="absolute inset-0 h-full w-full object-cover"
  />

  {/* Optional overlay for better text visibility */}
  <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/10 to-black/40"></div>

  {/* Content */}
  <div className="absolute inset-0 flex flex-col justify-between p-6 text-white">

    {/* Top Content */}
    <div>
      <h2 className="text-5xl font-bold tracking-tight">
        Contact Us
      </h2>

      <div className="mt-4 h-1.5 w-14 rounded-full bg-[#ff9933]" />

      <p className="mt-6 max-w-xs text-xl leading-8 text-white/95">
        Get in touch with us for any queries related to NMDFC
      </p>
    </div>

    {/* Bottom Content */}
    <div className="space-y-4">

      <div className="flex items-start gap-4">
        <MapPin
          size={28}
          className="mt-1 flex-shrink-0 text-white"
        />
        <p className="text-lg leading-8">
          1st Floor, Core-1, Scope Minar,
          <br />
          Laxmi Nagar, New Delhi,
          <br />
          110092
        </p>
      </div>

      <div className="flex items-center gap-4">
        <Phone size={28} className="text-white" />
        <p className="text-lg">
          22441442 / 44 / 52 / 53 / 55
        </p>
      </div>

      <div className="flex items-center gap-4">
        <Mail size={28} className="text-white" />
        <p className="text-lg">
          nmdfc123[at]gmail[Dot]com
        </p>
      </div>

      <div className="flex items-start gap-4">
        <Clock
          size={28}
          className="mt-1 flex-shrink-0 text-white"
        />
        <p className="text-lg leading-8">
          Monday to Friday: 9:30 AM - 6:00 PM
          <br />
          (Except Government Holidays)
        </p>
      </div>

    </div>

  </div>
</section>

            {/* Right Side Section */}
            <section className="space-y-4">
              <div id="grievance-section" className="overflow-hidden rounded-[32px] border border-gray-200 bg-white shadow-sm">
                <button
                  type="button"
                  onClick={() => setIsContactSectionOpen((prev) => !prev)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-[#0d4f4d] transition hover:bg-gray-50"
                >
                  <div>
                    <div className="text-xl font-bold">Register A Grievance With Us</div>
                  
                  </div>
                  <span className="text-2xl font-bold text-[#0d4f4d]">
                    {isContactSectionOpen ? "−" : "+"}
                  </span>
                </button>

                {isContactSectionOpen && (
                  <div className="border-t border-gray-200 p-6">
                    <form className="space-y-5" onSubmit={handleSubmit} noValidate>
                      <div className="grid gap-5 sm:grid-cols-2">
                        <label htmlFor="grievance-name" className="block">
                          <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Name<span className="text-red-500 ml-0.5">*</span>
                          </span>
                          <input
                            ref={grievanceNameRef}
                            id="grievance-name"
                            type="text"
                            value={grievanceName}
                            onChange={(e) => {
                              setGrievanceName(e.target.value);
                              if (grievanceErrors.name) {
                                setGrievanceErrors((prev) => ({ ...prev, name: "" }));
                              }
                            }}
                            placeholder="Enter Name"
                            aria-required="true"
                            aria-invalid={Boolean(grievanceErrors.name)}
                            aria-describedby={grievanceErrors.name ? "grievance-name-error" : undefined}
                            className={`w-full rounded-md border ${
                              grievanceErrors.name
                                ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                                : "border-gray-200 focus:border-[#0d4f4d] focus:ring-[#0d4f4d]"
                            } bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:ring-1`}
                          />
                          {grievanceErrors.name && (
                            <p
                              id="grievance-name-error"
                              className="mt-1 text-xs text-red-500"
                              role="alert"
                              aria-live="polite"
                            >
                              {grievanceErrors.name}
                            </p>
                          )}
                        </label>

                        <label htmlFor="grievance-phone" className="block">
                          <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Mobile Number<span className="text-red-500 ml-0.5">*</span>
                          </span>
                          <input
                            ref={grievancePhoneRef}
                            id="grievance-phone"
                            type="tel"
                            value={grievancePhone}
                            onChange={(e) => {
                              const sanitizedValue = e.target.value.replace(/\D/g, "").slice(0, 10);
                              phoneCheckId.current += 1;
                              setGrievancePhone(sanitizedValue);
                              setIsPhoneVerified(false);
                              grievanceUserIdRef.current = null;
                              otpUserIdRef.current = null;
                              setIsNewGrievanceUser(false);
                              grievanceUserCreatedRef.current = false;
                              if (grievanceErrors.phone) {
                                setGrievanceErrors((prev) => ({ ...prev, phone: "" }));
                              }
                              if (sanitizedValue.length === 10) {
                                checkGrievanceMobile(sanitizedValue);
                              }
                            }}
                            onBlur={handlePhoneBlur}
                            maxLength={10}
                            placeholder="Enter Mobile Number"
                            aria-required="true"
                            aria-invalid={Boolean(grievanceErrors.phone)}
                            aria-describedby={grievanceErrors.phone ? "grievance-phone-error" : undefined}
                            className={`w-full rounded-md border ${
                              grievanceErrors.phone
                                ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                                : "border-gray-200 focus:border-[#0d4f4d] focus:ring-[#0d4f4d]"
                            } bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:ring-1`}
                          />
                          {grievanceErrors.phone && (
                            <p
                              id="grievance-phone-error"
                              className="mt-1 text-xs text-red-500"
                              role="alert"
                              aria-live="polite"
                            >
                              {grievanceErrors.phone}
                            </p>
                          )}
                        </label>
                      </div>

                      <div className="grid gap-5 sm:grid-cols-2">
                        <div className="block relative" ref={dropdownRef}>
                          <span id="grievance-category-label" className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Grievance With<span className="text-red-500 ml-0.5">*</span>
                          </span>
                          <div
                            ref={grievanceCategoryRef}
                            id="grievance-category"
                            tabIndex={0}
                            role="combobox"
                            aria-labelledby="grievance-category-label"
                            aria-controls="grievance-category-listbox"
                            aria-expanded={isGrievanceOpen}
                            aria-haspopup="listbox"
                            aria-required="true"
                            aria-invalid={Boolean(grievanceErrors.category)}
                            aria-describedby={grievanceErrors.category ? "grievance-category-error" : undefined}
                            onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setIsGrievanceOpen((prev) => !prev);
                              }
                            }}
                            className={`flex w-full cursor-pointer items-center justify-between rounded-md border bg-white px-3 py-2.5 text-sm transition outline-none ${
                              grievanceErrors.category
                                ? "border-red-500 ring-1 ring-red-500"
                                : isGrievanceOpen
                                ? "border-[#0d4f4d] ring-1 ring-[#0d4f4d]"
                                : "border-gray-200"
                            }`}
                            onClick={() => setIsGrievanceOpen(!isGrievanceOpen)}
                          >
                            <span className="truncate">
                              {grievanceCategoryState.status === "loading"
                                ? "Loading options..."
                                : grievanceCategoryState.status === "failed"
                                  ? "Options are unavailable"
                                : selectedGrievance
                                  ? grievanceOptions.find((opt) => opt.value === selectedGrievance)?.displayLabel ||
                                    grievanceOptions.find((opt) => opt.value === selectedGrievance)?.label
                                  : "Select Grievance Category"}
                            </span>
                            <svg
                              className={`h-4 w-4 transform transition-transform duration-200 text-[#0d4f4d] ${
                                isGrievanceOpen ? "rotate-180" : ""
                              }`}
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path
                                fillRule="evenodd"
                                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </div>

                          {grievanceErrors.category && (
                            <p
                              id="grievance-category-error"
                              className="mt-1 text-xs text-red-500"
                              role="alert"
                              aria-live="polite"
                            >
                              {grievanceErrors.category}
                            </p>
                          )}

                          {grievanceCategoryState.status === "failed" && (
                            <div className="mt-1 flex items-center justify-between gap-2">
                              <p className="text-xs text-red-500" role="alert">
                                Unable to load grievance categories.
                              </p>
                              <button
                                type="button"
                                onClick={() => dispatch(fetchCategorySubcategories())}
                                className="shrink-0 text-xs font-semibold text-[#0d4f4d] underline"
                              >
                                Retry
                              </button>
                            </div>
                          )}

                          {isGrievanceOpen && grievanceOptions.length > 0 && (
                            <div
                              id="grievance-category-listbox"
                              role="listbox"
                              aria-labelledby="grievance-category-label"
                              className="absolute left-0 top-[72px] z-50 w-full rounded-md border border-gray-100 bg-white py-1.5 shadow-lg"
                            >
                              {grievanceOptions.map((option) => (
                                <div
                                  key={option.value}
                                  role="option"
                                  aria-selected={selectedGrievance === option.value}
                                  className="cursor-pointer px-4 py-2.5 text-[14px] text-[#1B476F] hover:bg-gray-50 transition-colors"
                                  onClick={() => {
                                    setSelectedGrievance(option.value);
                                    setIsGrievanceOpen(false);
                                    setGrievanceErrors((prev) => ({
                                      ...prev,
                                      category: "",
                                      subCategory: "",
                                    }));
                                  }}
                                >
                                  {option.displayLabel || option.label}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        {!isNmdfcGrievanceSelected && (
                        <div className="block relative" ref={subCategoryDropdownRef}>
                          <span id="grievance-subcategory-label" className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Sub-Category<span className="text-red-500 ml-0.5">*</span>
                          </span>

                          {isOtherGrievanceSelected ? (
                            <input
                              ref={grievanceSubCategoryRef}
                              id="grievance-subcategory"
                              type="text"
                              value={subCategory}
                              onChange={(e) => {
                                setSubCategory(e.target.value);
                                if (grievanceErrors.subCategory) {
                                  setGrievanceErrors((prev) => ({ ...prev, subCategory: "" }));
                                }
                              }}
                              placeholder="Enter Sub-Category"
                              aria-required="true"
                              aria-invalid={Boolean(grievanceErrors.subCategory)}
                              aria-describedby={grievanceErrors.subCategory ? "grievance-subcategory-error" : undefined}
                              className={`w-full rounded-md border ${
                                grievanceErrors.subCategory
                                  ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                                  : "border-gray-200 focus:border-[#0d4f4d] focus:ring-[#0d4f4d]"
                              } bg-white px-3 py-2.5 text-sm text-[#0d4f4d] outline-none transition focus:ring-1`}
                            />
                          ) : isSubCategoryLoading ? (
                            <input
                              type="text"
                              disabled
                              value="Loading options..."
                              className="w-full rounded-md border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-gray-400 outline-none cursor-wait"
                            />
                          ) : subCategoryError ? (
                            <div>
                              <input
                                type="text"
                                disabled
                                value="Options are unavailable"
                                className="w-full rounded-md border border-red-200 bg-red-50 px-3 py-2.5 text-sm text-red-500 outline-none cursor-not-allowed"
                              />
                              <div className="mt-1 flex items-center justify-between gap-2">
                                <p className="text-xs text-red-500" role="alert">
                                  {subCategoryError}
                                </p>
                                <button
                                  type="button"
                                  onClick={handleSubCategoryRetry}
                                  className="shrink-0 text-xs font-semibold text-[#0d4f4d] underline"
                                >
                                  Retry
                                </button>
                              </div>
                            </div>
                          ) : subCategoryList.length > 0 ? (
                            <>
                              <div
                                ref={grievanceSubCategoryRef}
                                id="grievance-subcategory"
                                tabIndex={0}
                                role="combobox"
                                aria-labelledby="grievance-subcategory-label"
                                aria-controls="grievance-subcategory-listbox"
                                aria-expanded={isSubCategoryOpen}
                                aria-haspopup="listbox"
                                aria-required="true"
                                aria-invalid={Boolean(grievanceErrors.subCategory)}
                                aria-describedby={grievanceErrors.subCategory ? "grievance-subcategory-error" : undefined}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    setIsSubCategoryOpen(!isSubCategoryOpen);
                                  }
                                }}
                                className={`flex w-full cursor-pointer items-center justify-between rounded-md border bg-white px-3 py-2.5 text-sm transition outline-none ${
                                  grievanceErrors.subCategory
                                    ? "border-red-500 ring-1 ring-red-500"
                                    : isSubCategoryOpen
                                    ? "border-[#0d4f4d] ring-1 ring-[#0d4f4d]"
                                    : "border-gray-200"
                                }`}
                                onClick={() => setIsSubCategoryOpen(!isSubCategoryOpen)}
                              >
                                <span className="truncate">
                                  {subCategory
                                    ? subCategoryList.find((opt) => opt.value === subCategory)?.label
                                    : "Select Sub-Category"}
                                </span>
                                <svg
                                  className={`h-4 w-4 transform transition-transform duration-200 text-[#0d4f4d] ${
                                    isSubCategoryOpen ? "rotate-180" : ""
                                  }`}
                                  fill="currentColor"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>

                              {isSubCategoryOpen && (
                                <div
                                  id="grievance-subcategory-listbox"
                                  role="listbox"
                                  aria-labelledby="grievance-subcategory-label"
                                  className="absolute left-0 top-[72px] z-50 w-full rounded-md border border-gray-100 bg-white py-1.5 shadow-lg"
                                >
                                  <div className="max-h-56 overflow-y-auto">
                                    {subCategoryList.map((option) => (
                                      <div
                                        key={option.value}
                                        role="option"
                                        aria-selected={subCategory === option.value}
                                        className="cursor-pointer px-4 py-2.5 text-[14px] text-[#1B476F] hover:bg-gray-50 transition-colors"
                                        onClick={() => {
                                          setSubCategory(option.value);
                                          setSubCategoryReferenceId(option.value);
                                          setSubCategoryReferenceName(option.label);
                                          setIsSubCategoryOpen(false);
                                          if (grievanceErrors.subCategory) {
                                            setGrievanceErrors((prev) => ({ ...prev, subCategory: "" }));
                                          }
                                        }}
                                      >
                                        {option.label}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <input
                              type="text"
                              disabled
                              placeholder="Select Sub-Category"
                              className="w-full rounded-md border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm text-gray-400 outline-none cursor-not-allowed"
                            />
                          )}

                          {grievanceErrors.subCategory && (
                            <p
                              id="grievance-subcategory-error"
                              className="mt-1 text-xs text-red-500"
                              role="alert"
                              aria-live="polite"
                            >
                              {grievanceErrors.subCategory}
                            </p>
                          )}
                        </div>
                        )}
                      </div>

                      <label htmlFor="grievance-description" className="block">
                        <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                          Grievance Description<span className="text-red-500 ml-0.5">*</span>
                        </span>
                        <textarea
                          ref={grievanceDescriptionRef}
                          id="grievance-description"
                          rows="3"
                          value={grievanceDescription}
                          onChange={(e) => {
                            setGrievanceDescription(e.target.value);
                            if (grievanceErrors.description) {
                              setGrievanceErrors((prev) => ({ ...prev, description: "" }));
                            }
                          }}
                          placeholder="Enter Grievance Description"
                          aria-required="true"
                          aria-invalid={Boolean(grievanceErrors.description)}
                          aria-describedby={grievanceErrors.description ? "grievance-description-error" : undefined}
                          className={`w-full rounded-md border ${
                            grievanceErrors.description
                              ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                              : "border-gray-200 focus:border-[#0d4f4d] focus:ring-[#0d4f4d]"
                          } bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:ring-1 resize-none`}
                        />
                        {grievanceErrors.description && (
                          <p
                            id="grievance-description-error"
                            className="mt-1 text-xs text-red-500"
                            role="alert"
                            aria-live="polite"
                          >
                            {grievanceErrors.description}
                          </p>
                        )}
                      </label>

                      <div className="block">
                        <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                          Attach Supporting Files
                        </span>
                        <input
                          type="file"
                          className="hidden"
                          ref={fileInputRef}
                          onChange={(e) => {
                            handleFileChange(e);
                            if (grievanceErrors.file) {
                              setGrievanceErrors((prev) => ({ ...prev, file: "" }));
                            }
                          }}
                          accept=".pdf,.jpg,.jpeg,.png"
                          aria-describedby={grievanceFileError || grievanceErrors.file ? "grievance-file-error" : undefined}
                        />

                        <div
                          ref={grievanceFileRef}
                          tabIndex={0}
                          role="button"
                          aria-label="Upload supporting document. Drag and drop or click to upload"
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              if (!attachedFile && grievanceUploadStatus !== "uploading") {
                                fileInputRef.current?.click();
                              }
                            }
                          }}
                          onClick={() => !attachedFile && grievanceUploadStatus !== "uploading" && fileInputRef.current?.click()}
                          className={`flex flex-col items-center justify-center w-full rounded-md border-2 border-dashed ${
                            grievanceFileError || grievanceErrors.file
                              ? "border-red-500 bg-red-50/20"
                              : attachedFile
                              ? "border-[#0d4f4d] bg-[#f0f9f8]"
                              : "border-[#2eb3a8] bg-[#fdfdfd] hover:bg-gray-50 cursor-pointer"
                          } py-6 px-4 transition outline-none focus:ring-2 focus:ring-[#0d4f4d]`}
                        >
                          {attachedFile ? (
                            <div className="flex items-center gap-3">
                              <span className="text-[#0d4f4d] font-semibold text-sm">{attachedFile.name}</span>
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  removeGrievanceFile();
                                  if (grievanceErrors.file) {
                                    setGrievanceErrors((prev) => ({ ...prev, file: "" }));
                                  }
                                }}
                                disabled={grievanceUploadStatus === "deleting"}
                                className="p-1 rounded-full hover:bg-red-100 text-red-500 transition disabled:cursor-not-allowed disabled:opacity-50"
                                aria-label="Remove supporting document"
                              >
                                <X size={16} />
                              </button>
                              {grievanceUploadStatus === "deleting" && <span className="text-xs text-gray-500">Removing...</span>}
                            </div>
                          ) : grievanceUploadStatus === "uploading" ? (
                            <p className="text-sm font-medium text-[#0d4f4d]">Uploading document...</p>
                          ) : (
                            <>
                              <div className="mb-2 flex h-8 w-8 items-center justify-center rounded-full bg-[#0d4f4d]">
                                <Upload className="h-4 w-4 text-white" />
                              </div>
                              <p className="text-sm text-gray-800 font-medium">
                                Drag and Drop or <span className="text-[#2eb3a8]">Click to upload</span>
                              </p>
                              <p className="mt-1 text-xs text-gray-500">
                                Supported Formats: PDF, JPG, and PNG ; Max Size: less than 1MB
                              </p>
                            </>
                          )}
                        </div>
                      </div>

                      {(grievanceFileError || grievanceErrors.file) && (
                        <p id="grievance-file-error" className="text-xs text-red-500" role="alert" aria-live="polite">
                          {grievanceFileError || grievanceErrors.file}
                        </p>
                      )}

                      {grievanceSubmitError && (
                        <p id="grievance-submit-error" className="text-xs text-red-500" role="alert" aria-live="polite">
                          {grievanceSubmitError}
                        </p>
                      )}

                      <button
                        type="submit"
                        disabled={grievanceState.submitStatus === "loading" || grievanceUploadStatus === "uploading" || grievanceUploadStatus === "deleting"}
                        className="mt-2 w-full rounded-full bg-[#0d4f4d] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#156e6b] disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {grievanceState.submitStatus === "loading"
                          ? "Submitting..."
                          : isPhoneVerified
                            ? "submit"
                            : "Verify Number"}
                      </button>
                
    
                    </form>
                  </div>
                )}
              </div>

              <div id="alumni-section" className="overflow-hidden rounded-[32px] border border-gray-200 bg-white shadow-sm">
                <button
                  type="button"
                  onClick={() => setIsAlumniSectionOpen((prev) => !prev)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-[#0d4f4d] transition hover:bg-gray-50"
                >
                  <div>
                    <div className="text-xl font-bold">Alumni Form (Only for Education Loan)</div>
                   
                  </div>
                  <span className="text-2xl font-bold text-[#0d4f4d]">
                    {isAlumniSectionOpen ? "−" : "+"}
                  </span>
                </button>

                {isAlumniSectionOpen && (
                  <div className="border-t border-gray-200 p-6">
                    <form className="space-y-5" onSubmit={handleAlumniSubmit}>
                      <div className="grid gap-5 sm:grid-cols-2">
                        <label className="block">
                          <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Name<span className="text-red-500 ml-0.5">*</span>
                          </span>
                          <input
                            type="text"
                            value={alumniForm.name}
                            onChange={(e) => setAlumniForm((prev) => ({ ...prev, name: e.target.value }))}
                            placeholder="Enter Name"
                            required
                            className="w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#0d4f4d] focus:ring-1 focus:ring-[#0d4f4d]"
                          />
                        </label>

                        <label className="block">
                          <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Email ID<span className="text-red-500 ml-0.5">*</span>
                          </span>
                          <input
                            type="email"
                            value={alumniForm.email}
                            onChange={(e) => {
                              setAlumniForm((prev) => ({ ...prev, email: e.target.value }));
                              if (alumniEmailError) {
                                setAlumniEmailError("");
                              }
                            }}
                            onBlur={() => validateEmailAddress(alumniForm.email)}
                            placeholder="Enter Email ID"
                            required
                            className="w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#0d4f4d] focus:ring-1 focus:ring-[#0d4f4d]"
                          />
                          {alumniEmailError && (
                            <p className="mt-1 text-xs text-red-500">{alumniEmailError}</p>
                          )}
                        </label>
                      </div>

                      <div className="grid gap-5 sm:grid-cols-2">
                        <label className="block">
                          <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Education Course/Degree<span className="text-red-500 ml-0.5">*</span>
                          </span>
                          <input
                            type="text"
                            value={alumniForm.course}
                            onChange={(e) => setAlumniForm((prev) => ({ ...prev, course: e.target.value }))}
                            placeholder="Enter Course/Degree"
                            required
                            className="w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#0d4f4d] focus:ring-1 focus:ring-[#0d4f4d]"
                          />
                        </label>

                        <label className="block">
                          <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Education Completion Date<span className="text-red-500 ml-0.5">*</span>
                          </span>
                         <input
  type="date"
  value={alumniForm.completionDate}
    onClick={openDatePicker}
  max={today}
  onKeyDown={handleDateKeyDown}
  onChange={(e) => {
    const selectedDate = e.target.value;

    if (selectedDate > today) {
      return;
    }

    setAlumniForm((prev) => ({
      ...prev,
      completionDate: selectedDate,
    }));
  }}
  required
  className="w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#0d4f4d] focus:ring-1 focus:ring-[#0d4f4d]"
/>
                        </label>
                      </div>
<div className="grid gap-5 sm:grid-cols-1">
                      <label className="block">
                          <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Name of Institute<span className="text-red-500 ml-0.5">*</span>
                          </span>
                          <input
                            type="text"
                            value={alumniForm.NameOfInstitute}
                            onChange={(e) => setAlumniForm((prev) => ({ ...prev, NameOfInstitute: e.target.value }))}
                            placeholder="Enter Name of Institute"
                            required
                            className="w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#0d4f4d] focus:ring-1 focus:ring-[#0d4f4d]"
                          />
                        </label>
                      </div>
                      <div className="grid gap-5 sm:grid-cols-2">
                        <label className="block">
                          <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Loan Account Number<span className="text-red-500 ml-0.5">*</span>
                          </span>
                          <input
                            type="text"
                            value={alumniForm.loanAccount}
                            onChange={(e) => {
                              const loanAccountNumber = e.target.value;
                              loanAccountRef.current = loanAccountNumber.trim();
                              dispatch(clearLoanVerification());
                              setLoanVerificationError("");
                              setAlumniForm((prev) => ({
                                ...prev,
                                loanAccount: loanAccountNumber,
                                loanDate: "",
                              }));
                            }}
                            onBlur={handleLoanAccountBlur}
                            placeholder="Enter Loan Account Number"
                            required
                            className="w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#0d4f4d] focus:ring-1 focus:ring-[#0d4f4d]"
                          />
                          {alumniState.loanVerification?.status === "loading" && (
                            <p className="mt-1 text-xs text-gray-500">Verifying loan account...</p>
                          )}
                          {alumniState.loanVerification?.status === "failed" && (
                            <p className="mt-1 text-xs text-red-500" role="alert">
                              {alumniState.loanVerification.error}
                            </p>
                          )}
                        </label>

                        <label className="block">
                          <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                            Loan Date<span className="text-red-500 ml-0.5">*</span>
                          </span>
                       <input
  type="date"
  value={alumniForm.loanDate}
  max={today}
  onKeyDown={handleDateKeyDown}
  onClick={openDatePicker}
  onChange={(e) => {
    const selectedDate = e.target.value;

    if (selectedDate > today) {
      return;
    }

    setAlumniForm((prev) => ({
      ...prev,
      loanDate: selectedDate,
    }));
  }}
  required
  className="w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#0d4f4d] focus:ring-1 focus:ring-[#0d4f4d]"
/>
                        </label>
                      </div>

                      <label className="block">
                        <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                          Current Profession Description<span className="text-red-500 ml-0.5">*</span>
                        </span>
                        <textarea
                          rows="3"
                          value={alumniForm.profession}
                          onChange={(e) => setAlumniForm((prev) => ({ ...prev, profession: e.target.value }))}
                          placeholder="Enter Current Profession Description"
                          required
                          className="w-full rounded-md border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition focus:border-[#0d4f4d] focus:ring-1 focus:ring-[#0d4f4d] resize-none"
                        />
                      </label>

                      <div className="block">
                        <span className="mb-1.5 block text-sm font-semibold text-gray-800">
                          Education Proof
                        </span>
                        <input
                          type="file"
                          className="hidden"
                          ref={alumniFileInputRef}
                          onChange={handleAlumniFileChange}
                          accept=".pdf,.jpg,.jpeg,.png"
                        />
                        <div
                          onClick={() => !alumniAttachedFile && alumniUploadStatus !== "uploading" && alumniFileInputRef.current?.click()}
                          className={`flex flex-col items-center justify-center w-full rounded-md border-2 border-dashed ${
                            alumniAttachedFile ? "border-[#0d4f4d] bg-[#f0f9f8]" : "border-[#2eb3a8] bg-[#fdfdfd] hover:bg-gray-50 cursor-pointer"
                          } py-6 px-4 transition`}
                        >
                          {alumniAttachedFile ? (
                            <div className="flex items-center gap-3">
                              <span className="text-[#0d4f4d] font-semibold text-sm">{alumniAttachedFile.name}</span>
                              <button
                                type="button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  removeAlumniFile();
                                }}
                                disabled={alumniUploadStatus === "deleting"}
                                className="p-1 rounded-full hover:bg-red-100 text-red-500 transition disabled:cursor-not-allowed disabled:opacity-50"
                                aria-label="Remove education proof"
                              >
                                <X size={16} />
                              </button>
                              {alumniUploadStatus === "deleting" && <span className="text-xs text-gray-500">Removing...</span>}
                            </div>
                          ) : alumniUploadStatus === "uploading" ? (
                            <p className="text-sm font-medium text-[#0d4f4d]">Uploading document...</p>
                          ) : (
                            <>
                              <div className="mb-2 flex h-8 w-8 items-center justify-center rounded-full bg-[#0d4f4d]">
                                <Upload className="h-4 w-4 text-white" />
                              </div>
                              <p className="text-sm text-gray-800 font-medium">
                                Drag and Drop or <span className="text-[#2eb3a8]">Click to upload</span>
                              </p>
                              <p className="mt-1 text-xs text-gray-500">
                                Supported Formats: PDF, JPG, and PNG ; Max Size: 1MB
                              </p>
                            </>
                          )}
                        </div>
                      </div>

                      {alumniFileError && (
                        <p className="text-xs text-red-500" role="alert">
                          {alumniFileError}
                        </p>
                      )}

                      <button
                        type="submit"
                        disabled={!isAlumniFormValid() || alumniState.status === "loading" || alumniUploadStatus === "uploading" || alumniUploadStatus === "deleting"}
                        className={`mt-2 w-full rounded-full px-5 py-3 text-sm font-semibold text-white transition ${
                          !isAlumniFormValid() || alumniState.status === "loading" || alumniUploadStatus === "uploading" || alumniUploadStatus === "deleting"
                            ? "cursor-not-allowed bg-gray-300"
                            : "bg-[#0d4f4d] hover:bg-[#156e6b]"
                        }`}
                      >
                        {alumniState.status === "loading" ? "Submitting..." : "Submit Alumni Form"}
                      </button>
                      {alumniState.status === "failed" && (
                        <p className="mt-2 text-sm text-red-500" role="alert">
                          {alumniState.error}
                        </p>
                      )}
                    </form>
                  </div>
                )}
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer />

      {/* OTP Verification Modal Overlay */}
      {showOtpModal && (
        <div className="fixed inset-0 z-[30000] flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm">
          <div ref={activeModal.startsWith("otp-") ? modalRef : undefined} role="dialog" aria-modal="true" aria-labelledby="contact-otp-title" aria-describedby={otpStep === 1 ? "contact-otp-description" : "contact-otp-description contact-otp-policy"} tabIndex={-1} className="w-full max-w-[500px] rounded-[32px] bg-white px-8 py-12 text-center shadow-2xl">
            {otpStep === 1 ? (
              <>
                <h2 id="contact-otp-title" className="mb-2 text-2xl font-bold text-[#1B476F]">
                  Verify Mobile Number
                </h2>
                <p id="contact-otp-description" className="mb-6 text-[15px] text-gray-600">
                  Please enter the 6-digit OTP sent to your mobile number.
                </p>
                
                <input
                  type="text"
                  maxLength="6"
                  aria-label="6-digit verification code"
                  autoComplete="one-time-code"
                  inputMode="numeric"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))}
                  placeholder="------"
                  className="w-full text-center tracking-[0.75em] rounded-md border border-gray-200 bg-white px-3 py-3 text-xl font-bold text-gray-800 outline-none transition focus:border-[#0d4f4d] focus:ring-1 focus:ring-[#0d4f4d] mb-3"
                />

                {grievanceSubmitError && (
                  <p className="mb-3 text-xs text-red-500" role="alert">
                    {grievanceSubmitError}
                  </p>
                )}

                {/* Resend OTP Section */}
                <div className="mb-8 flex items-center justify-end text-sm">
                  {canResend ? (
                    <button
                      type="button"
                      onClick={handleResendOtp}
                      className="font-semibold text-[#0d4f4d] underline hover:text-[#156e6b]"
                    >
                      Resend OTP
                    </button>
                  ) : (
                    <span className="text-gray-500">
                      Resend OTP in <span className="font-semibold text-[#0d4f4d]">{resendTimer}s</span>
                    </span>
                  )}
                </div>

                <div className="flex gap-4 justify-center">
                  <button
                    onClick={() => setShowOtpModal(false)}
                    className="w-1/2 rounded-full border border-gray-300 bg-white px-5 py-3 text-sm font-semibold text-gray-700 transition hover:bg-gray-50"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleOtpVerified}
                    disabled={otp.length !== 6 || grievanceState.otpStatus === "loading"}
                    className="w-1/2 rounded-full bg-[#0d4f4d] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#156e6b] disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {grievanceState.otpStatus === "loading" ? "Verifying..." : "Verify"}
                  </button>
                </div>
              </>
            ) : (
              <>
                {/* Green Success Icon */}
                <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#28a745] shadow-lg shadow-green-500/30">
                  <svg className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>

                <h2 id="contact-otp-title" className="mt-6 text-2xl font-bold text-[#1B476F]">
                  Verification Successful!
                </h2>
                <p id="contact-otp-description" className="mt-2 text-[15px] text-[#1B476F] max-w-[80%] mx-auto leading-relaxed">
                  Your mobile number has been successfully verified.
                </p>

                <button
                  onClick={async () => {
                    setIsPhoneVerified(true);
                    await handleFinalGrievanceSubmit();
                  }}
                  disabled={grievanceState.submitStatus === "loading"}
                  className="mt-8 rounded-full bg-[#0d4f4d] px-10 py-3 text-[15px] font-semibold text-white transition hover:bg-[#156e6b] disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {grievanceState.submitStatus === "loading" ? "Submitting..." : "Submit Grievance"}
                </button>
                      {grievanceSubmitError && (
                        <p className="mt-2 text-xs text-red-500" role="alert">
                          {grievanceSubmitError}
                        </p>
                      )}
                      <p id="contact-otp-policy" className="mt-2 text-[15px] text-[#1B476F] max-w-[80%] mx-auto leading-relaxed">By clicking Submit you Accept our Terms Of Use and Data Policy</p>
              </>
            )}
          </div>
        </div>
      )}

      {/* Success Modal Overlay (Final Form Submit) */}
      {showModal && (
        <div className="fixed inset-0 z-[30000] flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm">
          <div ref={activeModal === "submission" ? modalRef : undefined} role="dialog" aria-modal="true" aria-labelledby="contact-submission-title" aria-describedby="contact-submission-description contact-submission-policy" tabIndex={-1} className="w-full max-w-[500px] rounded-[32px] bg-white px-8 py-12 text-center shadow-2xl">
            
            {/* Green Success Icon */}
            <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#28a745] shadow-lg shadow-green-500/30">
              <svg className="h-10 w-10 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
              </svg>
            </div>

            {/* Title */}
            <h2 id="contact-submission-title" className="mt-6 text-2xl font-bold text-[#1B476F]">
              {submissionType === "alumni" ? "Alumni Form Submitted Successfully!" : "Grievance Submitted Successfully!"}
            </h2>

            {/* Success Details */}
            <p id="contact-submission-description" className="mt-6 text-[15px] text-[#1B476F] max-w-[80%] mx-auto leading-relaxed">
              Thank you for your submission. We will review it and get back to you shortly.
            </p>

            {/* Go to Home Button */}
            <button
              onClick={() => window.location.href = "/"}
              className="mt-8 rounded-full bg-[#0d4f4d] px-10 py-3 text-[15px] font-semibold text-white transition hover:bg-[#156e6b]"
            >
              Go to Home
            </button>
            <p id="contact-submission-policy" className="mt-2 text-[15px] text-[#1B476F] max-w-[80%] mx-auto leading-relaxed">By clicking Go to Home you Accept our Terms Of Use and Data Policy</p>
          </div>
        </div>
      )}

      {loanVerificationError && (
        <div
          className="fixed inset-0 z-[40000] flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm"
          ref={activeModal === "loan-error" ? modalRef : undefined}
          tabIndex={-1}
          role="alertdialog"
          aria-describedby="loan-verification-error-message"
          aria-modal="true"
          aria-labelledby="loan-verification-error-title"
        >
          <div className="w-full max-w-[420px] rounded-[24px] bg-white px-8 py-9 text-center shadow-2xl">
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100 text-2xl font-bold text-red-600">
              !
            </div>
            <h2 id="loan-verification-error-title" className="mt-5 text-xl font-bold text-[#1B476F]">
              Loan Account Verification Failed
            </h2>
            <p id="loan-verification-error-message" className="mt-3 text-[15px] leading-relaxed text-gray-600">{loanVerificationError}</p>
            <button
              type="button"
              onClick={() => setLoanVerificationError("")}
              className="mt-7 rounded-full bg-[#0d4f4d] px-10 py-3 text-sm font-semibold text-white transition hover:bg-[#156e6b]"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
